<template>
    <svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 6.8028L7 3.40002M7 3.40002L10.5 6.8028M7 3.40002L7 11.8M12.5999 14.5997H1.3999" stroke="#060606" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M22.7783 14H21.1309V5.40039H18.2051V4.00586H25.6973V5.40039H22.7783V14Z" fill="#060606"/>
    </svg>
</template>